
<script>
import { mapActions } from 'vuex';

export default {
  props: {
    city: {
      type: String,
    },
  },
  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
      addTitlePopup: 'Popups/addTitlePopup',
    }),

    openPopup() {
      this.togglePopup('order-call-with-message');
      this.addTitlePopup('<span>Подать</span> заявку на выкуп');
    },
  },
};
</script>

<template>
  <div class="section section_gray section_indents">
    <div class="container">
      <div class="flex flex-col lg:flex-row">
        <div class="w-full lg:w-1/2 mr-5">
          <div class="mb-3.5 md:mb-7">
            <p class="font-medium text-gray-600">Решили продать свой автомобиль?</p>
            <p class="font-medium text-gray-600">Тогда ПРАГМАТИКА Эксперт – это для Вас!</p>
          </div>

          <h1 class="text-gray-700 font-medium text-4xl mb-5"><span class="text-green font-medium">Выкуп авто </span>с&nbsp;пробегом {{ city }}</h1>

          <div class="text-gray-600">Мы предлагаем срочный выкуп автомобилей<br />
            с пробегом в любом из 10 автосалонов в СПб и СЗФО.</div>

          <div class="grid grid-cols-1 sm:grid-cols-3 gap-x-5 gap-y-5 my-6 md:my-12">
            <div
              class="flex items-center sm:block bg-white p-4 rounded-big-brand cursor-pointer transition ease-in-out duration-200 hover:shadow-brand"
              @click="openPopup"
            >
              <svg class="w-[46px] min-w-[46px] h-[46px] mr-4 sm:mr-0 mb-0 sm:mb-4">
                <use xlink:href="/public/images/svg/sprite.svg#maintenance"></use>
              </svg>
              <p class="text-sm text-gray-600">Бесплатная оценка и диагностика автомобиля</p>
            </div>

            <div
              class="flex items-center sm:block bg-white p-4 rounded-big-brand cursor-pointer transition ease-in-out duration-200 hover:shadow-brand"
              @click="openPopup"
            >
              <svg class="w-[46px] min-w-[46px] h-[46px] mr-4 sm:mr-0 mb-0 sm:mb-4">
                <use xlink:href="/public/images/svg/sprite.svg#wallet"></use>
              </svg>
              <p class="text-sm text-gray-600">Выплатим деньги сразу после оформления договора купли-продажи</p>
            </div>

            <div
              class="flex items-center sm:block bg-white p-4 rounded-big-brand cursor-pointer transition ease-in-out duration-200 hover:shadow-brand"
              @click="openPopup"
            >
              <svg class="w-[46px] min-w-[46px] h-[46px] mr-4 sm:mr-0 mb-0 sm:mb-4">
                <use xlink:href="/public/images/svg/sprite.svg#car-insurance"></use>
              </svg>
              <p class="text-sm text-gray-600">Оформим документы без скрытых платежей и комиссии</p>
            </div>
          </div>

          <div class="flex justify-between items-center mb-3.5 sm:mb-0">
            <div class="hidden sm:flex items-center ml-auto">
              <svg class="w-[24px] min-w-[24px] h-[32px] mr-2">
                <use xlink:href="/public/images/svg/sprite.svg#mouse"></use>
              </svg>
              <span class="text-sm text-gray-600">Ознакомиться подробнее</span>
            </div>
          </div>
        </div>

        <div class="relative w-full lg:w-1/2">
          <div class="static lg:absolute top-0 left-0 w-full lg:w-[calc(100%+(100vw-1220px)/4)] h-full flex items-center justify-center">
            <img
              class="w-full sm:w-10/12 lg:w-full max-w-[600px] h-auto"
              src="/public/images/pages/vikup/main.jpg"
              alt=""
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
